/* eslint-disable react/jsx-no-leaked-render */
import React, { Fragment, useEffect, useState } from 'react'
import styled from 'styled-components'
import { bool } from 'prop-types'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Dropdown from '@taglivros/oef_componentes/build/components/dropdown'

import {
  getNomeAssociado,
} from '../../api/autenticacao.servico'

import Menu from '../../components/Menu/Menu'
import Link from '../../components/Link/Link'
import LogoTAG from '../../components/LogoTAG/LogoTAG'
import { useGlobal } from '../../contexts/GlobalContext'
import { URLS } from '../../constants'
import { URLS_APP } from '../../config'
import { PERFIL, SAIR } from './constantsHeader'

const LogoImg = styled.a`
  cursor: pointer;
  height: auto;

  img {
    width: 50px;
  }

  @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
    order: 1;
    text-align: center;
    flex-grow: 1;
    flex-basis: 0;
  }
`

const estiloHeaderExterno = `
  border-bottom: 1px solid ${StyleGuide.cores.cinza200};
  margin: 0 auto;
  padding: 25px 0 15px;
  width: 100%;

  @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding: 10px 0;
  }
`

const estiloHeaderInterno = `
  .wrapperLinkLogo {
    @media(max-width: ${StyleGuide.mediaQuery.tablet}) {
      display: none;
    }
  }
`

const HeaderStyle = styled.header`
  align-items: center;
  background-color: #fff;
  display: flex;
  justify-content: ${( { headerInterno } ) => headerInterno ? 'space-between' : 'center'};
  padding: 7px 45px;
  z-index: ${( { headerInterno } ) => ( headerInterno ? '0' : '2' )};
  border-bottom: 1px solid #dadedf;

  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 50px;
  z-index: 9;

  > div {
    margin: 0;
    order: 2;

    span:nth-child(1) {
      margin: 0;
    }
  }

  .menu > div {
    width: auto;
  }

  .dropdown {
    align-items: center;
    display: inline-flex;
    margin-bottom: 0;
  }

  @media (max-width: ${StyleGuide.mediaQuery.tablet}) {
    padding: 5px 24px 5px 11.5px;
    > div {
      flex-grow: 1;
      flex-basis: 0;
      text-align: right;
    }
    .dropdown > span {
      margin: 0;
    }
  }

  ${( { headerInterno } ) => !headerInterno ? estiloHeaderExterno : estiloHeaderInterno}
`

const MenuWrapper = styled.div`
  order: 0;

  @media( max-width: ${StyleGuide.mediaQuery.tablet}) {
    flex-grow: 1;
    flex-basis: 0;
  }

  @media( min-width: ${StyleGuide.mediaQuery.tablet}) {
    display: none;
    order: auto;
  }
`

const Header = ( { headerInterno } ) => {
  const { fazLogout, getDadosGlobaisAssociado, shouldShowHeader, shouldShowMenu } = useGlobal()
  const [ nomeDoAssociado, setNomeDoAssociado ] = useState()

  useEffect(
    () => {
      setNomeDoAssociado( getNomeAssociado() )
    },
    [ getDadosGlobaisAssociado ]
  )

  const links = [
    <Link
      key="perfil"
      to={ `/${URLS.PERFIL}` }
    >
      { PERFIL }
    </Link>,
    <Link
      key="logout"
      onClick={ fazLogout }
      to={ `/${URLS.LOGOUT}` }
    >
      { SAIR }
    </Link>
  ]

  if ( !shouldShowHeader ) {
    return null
  }

  return (
    <HeaderStyle headerInterno={ headerInterno }>
      <LogoImg href={ URLS_APP.CANONICAL_URL }>
        <LogoTAG />
      </LogoImg>

      {headerInterno && shouldShowMenu && (
        <Fragment>
          <MenuWrapper as="nav">
            <Menu isMobile />
          </MenuWrapper>

          {nomeDoAssociado ? (
            <Dropdown
              className="dropdown"
              links={ links }
              listPosition="right: 50px;"
              listPositionMobile="right: 25px;"
              name={ nomeDoAssociado }
            />
          ) : (
            <Link
              key="logout"
              onClick={ fazLogout }
              to={ `/${URLS.LOGOUT}` }
            >
              {SAIR}
            </Link>
          )}
        </Fragment>
      )}
    </HeaderStyle>
  )
}

Header.defaultProps = {
  'headerInterno': false
}

Header.propTypes = {
  'headerInterno': bool
}

export default Header
